export default function formControlLabel({ variables, }) {
    return {
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    minHeight: variables.component_height_small,
                    marginLeft: `calc(-1 * ${variables.spacing_02})`,
                    marginRight: variables.spacing_05,
                    "&.Mui-disabled": {
                        cursor: "not-allowed",
                    },
                    "&:has(.MuiSwitch-root)": {
                        minHeight: "auto",
                        marginLeft: 0,
                        "& .MuiFormControlLabel-label": {
                            paddingTop: 0,
                            lineHeight: "normal",
                        },
                    },
                },
                label: {
                    fontSize: variables.type_body_font_size,
                    paddingTop: variables.spacing_01,
                },
            },
        },
    };
}
//# sourceMappingURL=formControlLabel.js.map